import React, { Component } from "react";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { isDesktop } from 'react-device-detect';
import { withNamespaces } from 'react-i18next';
//Miscellaneous
import Skeleton from "react-loading-skeleton";
import Swal from "sweetalert2";
import { Fade } from "react-awesome-reveal"

//Components
// import NoRecords from "../../../components/NoRecords/NoRecords";
import DataTable from "../../components/Datatable/DataTable";

//Icons
import { Icon } from "@iconify/react";


const msgListings = [
  { Id: 12842, content: "Your deposit order id D00008177 (1000.00) at 2022-08-29 17:11:40 has been rejected.", created_at: "2022-08-29", date: "2022-08-29", icon: "msg-ann", isChecked: false, msgType: "notification", read: 1, status: 1, title: "Deposit Reject", value: 12842 },
  { Id: 12842, content: "Your deposit order id D00008177 (1000.00) at 2022-08-29 17:11:40 has been rejected.", created_at: "2022-08-29", date: "2022-08-29", icon: "msg-ann", isChecked: false, msgType: "notification", read: 1, status: 1, title: "Deposit Reject", value: 12842 },
];

class Announcement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEdit: false,
      msgListings: [],
      loading: false,
      // page: this.props.activePage ? this.props.activePage : Number(process.env.REACT_APP_DATATABLE_PAGE),
      // limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
      sorted: null,
      totalPages: 0,
      totalRecords: 0,
      isInterval: false,
      unreadNotice: 0,
      unreadAnnouncement: 0
    };
  }

  componentDidMount() {
    this.setState({
      msgListings: msgListings
    })
  }

  componentWillUnmount() {
  }

  handleEdit = () => {
    this.setState({ showEdit: !this.state.showEdit })
  }

  handleAllChecked = (event) => {
    const msgListings = this.state.msgListings;
    msgListings.forEach(msgListing => (msgListing.isChecked = event.target.checked));
    this.setState({ msgListings: msgListings });
  };

  handleCheckChildElement = (event) => {
    const msgListings = this.state.msgListings;
    msgListings.forEach(msgListing => {
      if (msgListing.value === parseInt(event.target.value)) {
        msgListing.isChecked = event.target.checked;
      }
    });
    this.setState({ msgListings: msgListings });
  };

  handleRead = (event, type) => {
    event.preventDefault();
  }

  handleDelete = event => {
    event.preventDefault();
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const { t } = this.props;
    const truncate = (value) =>
      isDesktop ? (
        value?.length > 60 ? `${value.substring(0, 60)}...` : value
      ) : (
        value?.length > 40 ? `${value.substring(0, 40)}...` : value
      );
    const replaceUnknown = (value) => value.replace("&nbsp;", "");

    const icons = this.imageImport(
      require.context(
        "../../assets/images/message-center",
        false,
        /\.(png|jpe?g|svg)$/
      )
    );

    const rsData = this.state.msgListings.map((val, idx) => (
      <div className={`list-group-item ${this.state.showEdit && 'show'}`} onClick={(event) => this.props.handleChangePage(event, 'details', val.value, this.state.msgListings, 'announcement', val.status, this.state.page)}>
        {isDesktop ? (
          this.state.showEdit &&
          <input
            className="form-check-input"
            onChange={this.handleCheckChildElement}
            type="checkbox"
            checked={val.isChecked}
            value={val.value}
            onClick={(event) => event.stopPropagation()}
          />
        ) : (
          <input
            className="form-check-input"
            onChange={this.handleCheckChildElement}
            type="checkbox"
            checked={val.isChecked}
            value={val.value}
            onClick={(event) => event.stopPropagation()}
          />
        )
        }
        <div className="msg-icon-col">
          {
            !val.read &&
            <span className="notify-red-dot" />
          }
          <img src={icons['msg-ann.svg']} alt='msg-ann' />
        </div>
        {isDesktop ? (
          <>
            <h6>【<span>{val.title}</span>】</h6>
            <p>{truncate(replaceUnknown(val.content))}</p>
            <span>{val.date}</span>
          </>
        ) : (
          <div className="list-group-item-r">
            <label>
              <h6>【<span>{val.title}</span>】</h6>
              <span>{val.date}</span>
            </label>
            <p>{truncate(replaceUnknown(val.content))}</p>
          </div>
        )}
      </div>
    ));

    return (
      <Auxiliary>
        {
          isDesktop ? (
            <>
              <div className={`tab-pane fade ${this.props.activePanel === 2 ? "show active" : ""}`} id="msg-announcement" role="tabpanel">
                <div className="msg-list-col">
                  <div className="msg-edit-col" >
                    {this.state.showEdit &&
                      <div className="msg-edit-panel left">
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" value="" id="checkAll" onChange={this.handleAllChecked} key="checkAll" />
                          <label htmlFor="checkAll">
                          {t('global.all')}
                          </label>
                        </div>
                        <button className="btn text-icon" type="button" onClick={(event) => this.handleRead(event, "selectable")}>
                          <Icon icon="mdi:email-open-outline" />
                          {t('message.mark-as-read')}
                        </button>
                        <button className="btn text-icon trash" type="button" onClick={(event) => this.handleDelete(event)}>
                          <Icon icon="uil:trash-alt" />
                          {t('message.delete')}
                        </button>
                      </div>
                    }
                    <div className="msg-edit-panel right">
                      {this.state.showEdit ? (
                        <button className="btn text-icon" type="button" onClick={this.handleEdit}>
                          {t('message.done')}
                        </button>
                      ) : (
                        <>
                          <button className="btn text-icon" type="button" onClick={(event) => this.handleRead(event, "all")}>
                            <Icon icon="mdi:email-open-multiple-outline" />
                            {t('message.all-read')}
                          </button>
                          <button className="btn text-icon" type="button" onClick={this.handleEdit}>
                          {t('global.edit')}
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="msg-list">
                    <div className="msg-list-group">
                      {this.state.loading ? (
                        <Skeleton count={2} height={50} style={{ marginBottom: ".25rem" }} />
                      ) : (
                        <Fade duration={1000} triggerOnce>
                          <>{rsData}</>
                        </Fade>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>) : (
            <div className={`tab-pane fade ${this.props.activePanel === 2 ? "show active" : ""}`} id="msg-announcement" role="tabpanel">
              <div className="msg-list-col">
                <div className="msg-list">
                  <div className="msg-list-group">
                    {this.state.loading ? (
                      <Skeleton count={2} height={180} style={{ marginBottom: ".5rem" }} />
                    ) : (
                      <Fade duration={1000} triggerOnce>
                        <>{rsData}</>
                      </Fade>
                    )}
                  </div>
                </div>
              </div>
              <div className={`msg-edit-col ${this.state.showEdit && 'show'}`} >
                <div className="msg-edit-panel left">
                  <button className="btn text-icon" type="button" onClick={(event) => this.handleRead(event, 'selectable')}>
                  {t('message.mark-as-read')}
                  </button>
                </div>
                <div className="msg-edit-panel right">
                  <button className="btn text-icon trash" type="button" onClick={(event) => this.handleDelete(event)}>
                  {t('message.delete')}
                  </button>
                </div>
              </div>
            </div>
          )
        }
      </Auxiliary >
    );
  }
}

export default (withNamespaces('translation')(Announcement));
